import React from "react";
import "./PaintVisualizer.css";
import { Link } from "react-router-dom";
export default function PaintVisualizer() {
  const steps = [
    { img: "/assets/step1.png", title: "Step 1", text: "Choose a picture" },
    {
      img: "/assets/step2.png",
      title: "Step 2",
      text: "Try different colours",
    },
    {
      img: "/assets/step3.png",
      title: "Step 3",
      text: "Compare colour options",
    },
    { img: "/assets/step4.png", title: "Step 4", text: "Save and share!" },
  ];

  return (
    <section className="visualizer-section">
      <h2>Paint Visualizer</h2>
      <p className="subtitle">See your space in color before you paint.</p>

      <div className="steps-container">
        {steps.map((step, index) => (
          <div className="step-card" key={index}>
            <h4>{step.title}</h4>
            <div className="step-icon">
              <img src={step.img} alt={step.title} />
            </div>

            <p>{step.text}</p>
          </div>
        ))}
      </div>

      {/* <a
        href="https://visualizer.inventocube.com/"
        target="_blank"
        rel="noopener noreferrer"
      >
        <button className="cta-button">Visualise Your Favourite Shades</button>
      </a> */}
      <Link to="/paint-visualizer">
        <button className="cta-button">Visualise Your Favourite Shades</button>
      </Link>
    </section>
  );
}
